import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import {
  ControlProps,
  rankWith,
  isDescriptionHidden,
  isDateControl,
} from "@jsonforms/core";
import React, { useEffect, useState, useRef } from "react";
import { Dropdown } from "../../../../../../shadcn/components/custom/Dropdown";

export const DropdownFieldTypeRenderer = ({
  data,
  handleChange,
  path,
  schema,
  uischema,
}: ControlProps) => {
  const ctx = useJsonForms();
  const dropDownOptions = uischema?.options?.additionalData || {};
  const [value, setValue] = React.useState<any>(data === undefined ? {} : data);
  const [customError, setCustomError] = useState("");
  const positionRef = useRef<HTMLInputElement>(null);

  const show = uischema?.options?.show;
  useEffect(() => {
    if (show == false) {
      handleChange(path, {});
    }
  }, [show]);

  const handleOptionSelect = (item: any) => {
    handleChange(path, item);
    setValue(item);
  };

  useEffect(() => {
    const errorData = ctx?.core?.errors;
    let flag = false;
    errorData?.forEach((error: any) => {
      if (error?.instancePath === "/" + path) {
        setCustomError(error?.message);
        flag = true;
      } else if (
        error?.instancePath === "" &&
        error?.params?.missingProperty === path
      ) {
        setCustomError("Required Field");
        flag = true;
        return;
      }
    });

    if (!flag) setCustomError("");
    else {
      if (positionRef.current) {
        positionRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, [ctx?.core?.errors]);

  return show === false ? (
    <></>
  ) : (
    <div ref={positionRef} className="w-full relative ">
      <Dropdown
        dataSource={() => {
          return Promise.resolve(dropDownOptions);
        }}
        defaultSelected={
          value !== ""
            ? dropDownOptions.find((item: any) => value?.value === item.value)
            : undefined
        }
        selectIdentifier={true}
        onChange={(value: any) => handleOptionSelect(value)}
        valueKey="value"
        placeholder={schema?.title}
        styles={{
          dropdownItemsClass: "text-brand-borderGrey",
          hoverBgColor: "focus:bg-brand-lightOrange",
          hoverTextColor: "focus:text-brand-borderGrey",
          hideDot: true,
          outerContainer: `border-[1px] min-w-[130px]   w-full rounded-none h-[50px] font-openSans font-normal text-web-body-sm  mid:text-web-body-lg ${
            ctx?.core?.data?.[path]?.value
              ? "items-end text-brand-textLightGrey"
              : "text-brand-borderGrey"
          } leading-5 `,
        }}
      />

      <div
        className={`absolute top-1 text-[10px] transition-all duration-300  left-3 ${
          ctx?.core?.data?.[path]?.value
            ? "text-brand-borderGrey"
            : "text-transparent"
        }`}
      >
        {schema?.title}
      </div>
      {customError && (
        <label
          htmlFor="name"
          className={"text-brand-textRed text-web-body-sm ml-2"}
        >
          {customError}
        </label>
      )}
    </div>
  );
};

export default withJsonFormsControlProps(DropdownFieldTypeRenderer);
